import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map',
})
export class MapPipe implements PipeTransform {
  transform<T>(value: T, methodToPassData: (data: T) => any): any {
    if (typeof methodToPassData === 'function') {
      return methodToPassData(value);
    }
    return value;
  }
}
